// extracted by mini-css-extract-plugin
export default {"list":"missing-level-modal_list__zmOjc","row":"missing-level-modal_row__kDc2R","name":"missing-level-modal_name__9djbz"};